import React from 'react';

import { Icon } from '@rbilabs/component-library';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import LoadingAnimation from 'components/loading-animation';

import {
  AddressStyle,
  BottomServiceWrapper,
  ButtonContainer,
  CartOverlayButton,
  Container,
  Details,
  Heading,
  IconContainer,
  LocationOverlayButton,
  LocationStyle,
  Underline
} from './styled';
import { BottomServiceVariants, IBottomServiceModeViewProps } from './types';

export const BottomServiceModeView = React.forwardRef<HTMLDivElement, IBottomServiceModeViewProps>(
  (
    {
      isLoading = false,
      variant = BottomServiceVariants.DEFAULT,
      heading,
      details,
      icon,
      buttonContentText,
      buttonContentIcon,
      onBottomServiceClick = () => {},
      onButtonClick = () => {},
      buttonDisabled = false,
      className = ''
    },
    ref
  ) => {
    if (isLoading) {
      return (
        <Container variant={variant} className={className} ref={ref}>
          <LoadingAnimation fillColor={Styles.color.white} />
        </Container>
      );
    }
    let buttonVariant: ActionButtonVariants;
    switch (variant) {
      case BottomServiceVariants.IN_PROGRESS:
        buttonVariant = ActionButtonVariants.OUTLINE;
        break;
      case BottomServiceVariants.NO_STORE:
        buttonVariant = ActionButtonVariants.INVERSE;
        break;
      case BottomServiceVariants.DEFAULT:
      default:
        buttonVariant = ActionButtonVariants.INVERSE;
    }
    const isNoStoreAddressIcon = variant === BottomServiceVariants.NO_STORE;
    return (
      <Container variant={variant} className={className} ref={ref} data-testid="bottom-service">
        <BottomServiceWrapper>
          <LocationOverlayButton
            onClick={onBottomServiceClick}
            data-testid="bottom-service-location"
          ></LocationOverlayButton>
          <CartOverlayButton
            onClick={onButtonClick}
            disabled={buttonDisabled}
            data-testid="bottom-service-cart"
          ></CartOverlayButton>
          <IconContainer>{icon}</IconContainer>
          <Heading>{heading}</Heading>
          <Details>
            <LocationStyle>
              <AddressStyle>{details}</AddressStyle>
              {isNoStoreAddressIcon ? (
                <Icon icon="arrowRight" color="white" width="0.4rem" />
              ) : (
                <Icon icon="close" color="white" width="1.7rem" />
              )}
            </LocationStyle>
            <Underline />
          </Details>
          {buttonContentText && (
            <ButtonContainer>
              <ActionButton
                variant={buttonVariant}
                color={Styles.color.validated}
                size={ActionButtonSizes.SMALL}
                data-testid="bottom-service-button"
                disabled={buttonDisabled}
                startIcon={buttonContentIcon}
              >
                {buttonContentText}
              </ActionButton>
            </ButtonContainer>
          )}
        </BottomServiceWrapper>
      </Container>
    );
  }
);
